// extracted by mini-css-extract-plugin
export default {"white-background":"Notifications_white-background__9oo6+","wrapper":"Notifications_wrapper__CYBaf","notification_list":"Notifications_notification_list__475Yc"};